import { ColumnsConfigBuilder } from '@bingads-webui-campaign/summary-grid-helper';
import {
  ColumnImpressions, ColumnClicks, ColumnCTR, ColumnSpend, ColumnConversionsCredit, ColumnAdvertiserReportedRevenue,
  ColumnVideoCompletionRate, ColumnVideoViews, ColumnVideoViewsAt25Percent, ColumnVideoViewsAt50Percent, ColumnVideoViewsAt75Percent, ColumnCompletedVideoViews
} from '@bingads-webui-campaign/campaignui-common-columns';

import { ColumnAsset } from './asset';
import { ColumnAssetType } from './asset-type';
import { ColumnStatus } from './status';
import { ColumnPinnedField } from './pinned-field';
import { ColumnAssetSource } from './asset-source';
import { ColumnAssetMMA } from './asset-mma';
import { ColumnAssetId } from './asset-id';
import { ColumnPolicyStatus } from './policy-status';

export function getColumnsConfig(options) {
  const { adType, adSubType } = options.scope.values;
  const builder = new ColumnsConfigBuilder();
  builder.addCategory('Attributes', category => category.addColumns([
    ColumnStatus,
    ...adType === 'ResponsiveSearch' ? [ColumnAsset] : [ColumnAssetMMA],
    ColumnAssetId,
    ColumnAssetType,
    ColumnAssetSource,
    ...adType === 'ResponsiveSearch' ? [ColumnPinnedField] : [],
    ...(options.AssetBasedEditorialForRSA && adType === 'ResponsiveSearch') || (options.AssetBasedEditorialForAIM && adSubType === 'native') ? [ColumnPolicyStatus] : [],
    ColumnImpressions,
    ColumnClicks,
    ColumnCTR,
    ColumnSpend,
    ...options.SearchAssetConversionColumn ? [ColumnConversionsCredit, ColumnAdvertiserReportedRevenue] : [],
    ...options.ShowVideoMetrics && adType === 'Responsive' ? [ColumnVideoViews, ColumnVideoCompletionRate, ColumnVideoViewsAt25Percent, ColumnVideoViewsAt50Percent, ColumnVideoViewsAt75Percent, ColumnCompletedVideoViews] : [],
  ]))
    .setLockedColumns([
      ColumnStatus,
      ...adType === 'ResponsiveSearch' ? [ColumnAsset] : [ColumnAssetMMA],
      ColumnAssetId,
      ColumnAssetType,
      ColumnAssetSource,
      ...adType === 'ResponsiveSearch' ? [ColumnPinnedField] : [],
      ...options.AssetBasedEditorial && (adType === 'ResponsiveSearch' || adSubType === 'native') ? [ColumnPolicyStatus] : [],
      ColumnImpressions,
      ColumnClicks,
      ColumnCTR,
      ColumnSpend,
      ...options.SearchAssetConversionColumn ? [ColumnConversionsCredit, ColumnAdvertiserReportedRevenue] : [],
      ...options.ShowVideoMetrics && adType === 'Responsive' ? [ColumnVideoViews, ColumnVideoCompletionRate, ColumnVideoViewsAt25Percent, ColumnVideoViewsAt50Percent, ColumnVideoViewsAt75Percent, ColumnCompletedVideoViews] : [],
    ])
    .setSelectedColumns([
      ColumnStatus,
      ...adType === 'ResponsiveSearch' ? [ColumnAsset] : [ColumnAssetMMA],
      ColumnAssetId,
      ColumnAssetType,
      ColumnAssetSource,
      ...adType === 'ResponsiveSearch' ? [ColumnPinnedField] : [],
      ...options.AssetBasedEditorial && (adType === 'ResponsiveSearch' || adSubType === 'native') ? [ColumnPolicyStatus] : [],
      ColumnImpressions,
      ColumnClicks,
      ColumnCTR,
      ColumnSpend,
      ...options.SearchAssetConversionColumn ? [ColumnConversionsCredit, ColumnAdvertiserReportedRevenue] : [],
      ...options.ShowVideoMetrics && adType === 'Responsive' ? [ColumnVideoViews, ColumnVideoCompletionRate, ColumnVideoViewsAt25Percent, ColumnVideoViewsAt50Percent, ColumnVideoViewsAt75Percent, ColumnCompletedVideoViews] : [],
    ]);
  return builder.getColumnsConfig(options);
}
